import React, { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { SITE } from "@/lib/site-data";
import Logo from "@/components/Logo";

const LINKS = [
  { href: "#sobre", label: "Sobre" },
  { href: "#servicos", label: "Serviços" },
  { href: "#videos", label: "Depoimentos" },
  { href: "#avaliacoes", label: "Avaliações" },
  { href: "#contato", label: "Contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onS = () => setScrolled(window.scrollY > 12);
    onS();
    window.addEventListener("scroll", onS);
    return () => window.removeEventListener("scroll", onS);
  }, []);
  return (
    <header className={`sticky top-0 left-0 right-0 z-40 transition-all ${scrolled ? "bg-white/90 backdrop-blur-md border-b border-stone-100" : "bg-transparent"}`} data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="navbar-logo">
          <Logo className="h-9 md:h-10 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-stone-700">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="hover:text-orange-600 transition-colors">{l.label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={SITE.whatsappLink} target="_blank" rel="noopener noreferrer" data-testid="navbar-whatsapp-btn" className="hidden sm:inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors">
            <MessageCircle className="w-4 h-4" /> Agendar
          </a>
          <button className="md:hidden h-10 w-10 rounded-xl border border-stone-200 flex items-center justify-center" onClick={() => setOpen((v) => !v)} aria-label="Abrir menu" data-testid="navbar-menu-btn">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 space-y-3">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-stone-700 font-medium">{l.label}</a>
          ))}
        </div>
      )}
    </header>
  );
}
